// removed by extract-text-webpack-plugin
module.exports = {"restrictions-tooltip":"restrictions-tooltip","restrictionsTooltip":"restrictions-tooltip","restriction":"restriction","check-icon":"check-icon","checkIcon":"check-icon","error-icon":"error-icon","errorIcon":"error-icon"};


//////////////////
// WEBPACK FOOTER
// ./src/components/portal/controls/restrictionsTooltip/style.scss
// module id = 959
// module chunks = 0